import { useTranslations } from "../../hooks/useTranslations";
import { Evaluation } from "../../types";

interface Props {
  id?: string;
  value?: Evaluation;
  onChange: (value: Evaluation) => void;
}

const EvaluationSelect = ({ id, value, onChange }: Props) => {
  const { i18n } = useTranslations();
  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value as Evaluation)}
    >
      <option value="competence">
        {i18n.bilanzOnline.evaluation.options.competence}
      </option>
      <option value="fiscal">
        {i18n.bilanzOnline.evaluation.options.fiscal}
      </option>
    </select>
  );
};

export default EvaluationSelect;
